// src/theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#BC965E", // 🌟 your golden color (you can change it)
    },
    text: {
      primary: "#FFFFFF", // all text white
    },
    secondary: {
      main: "#FFFFFF", // optional
    },
    background: {
      default: "#f5f5f5", // optional
      paper: "rgba(255, 215, 0, 0.1)", // subtle gold transparency
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    // color: "white", // optional customization
  },
  components: {
    // ✅ For TextFields (Input + Label)
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(255,255,255,0.6)", // white outline
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#BC965E", // gold on hover
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#BC965E", // gold on focus
          },
          "& input": {
            color: "#FFFFFF", // input text white
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "rgba(255,255,255,0.7)", // label/placeholder white
          "&.Mui-focused": {
            color: "#BC965E", // gold when focused
          },
        },
      },
    },
    // ✅ For Buttons
    MuiButton: {
      styleOverrides: {
        root: {
          color: "#FFFFFF", // white text
          textTransform: "none",
          fontWeight: 600,
          "&.MuiButton-contained": {
            backgroundColor: "#BC965E",
            "&:hover": {
              backgroundColor: "#A27E4E", // darker gold on hover
            },
          },
        },
      },
    },
  },
});

export default theme;